import PropTypes from 'prop-types';

/**
 * Describes the resource shown on the left axis of a ResourceWeeklySchedule.
 * See UserSchedule/userAxis.js and EquipmentSchedule/equipmentAxis.js.
 */
export const resourceAxisPropType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  shiftField: PropTypes.string.isRequired,
  headerTitle: PropTypes.string.isRequired,
  unassignedLabel: PropTypes.string.isRequired,
  RowAvatar: PropTypes.elementType.isRequired,
  getAssignment: PropTypes.func.isRequired,
  getReassignArgs: PropTypes.func.isRequired,
});

/**
 * Rows are normalized by each axis' row hook so the shared components
 * can render and validate drops without knowing the resource type.
 */
export const resourceRowPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  subtitle: PropTypes.string,
  divisionIds: PropTypes.arrayOf(PropTypes.string),
});
